var borders_default = {
  "borderT": "GlW3Y",
  "borderB": "_2Qbs1",
  "borderL": "pj7cd",
  "borderR": "Uw4df",
  "borderColorOverride": "BIJUa"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
